module.exports = __webpack_public_path__ + "img/upload-excel.10981233.png";